<template>
    <div class="ma-4">
        <ClientNav/>
        <v-row dense>
            <v-col cols="12">
                <v-card>
                    <v-card-title style="background-color: #2b3990">
                        <span class="headline white--text">{{ titleForm }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-form ref="form">
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <DatePicker
                                            :default-date="newDate"
                                            v-model="newDate"
                                            label="Assessment Date"
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                            v-model="newInterviewer"
                                            label="Interviewer"
                                            :rules="requiredRules"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-textarea
                                            v-model="newHistory"
                                            label="History"
                                            outlined
                                            :rules="requiredRules"
                                        ></v-textarea>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-textarea
                                            v-model="newMedicalSupport"
                                            label="Medical Support"
                                            outlined
                                            :rules="requiredRules"
                                        ></v-textarea>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                            v-model="newPhysician"
                                            label="Physician"
                                            :rules="requiredRules"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <DatePicker
                                            :default-date="newPreviousPhysical"
                                            v-model="newPreviousPhysical"
                                            label="Most Recent Physical"
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-textarea
                                            v-model="newPhysicalNotes"
                                            label="Physical Notes"
                                            outlined
                                            :rules="requiredRules"
                                        ></v-textarea>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                            v-model="newDentist"
                                            label="Dentist"
                                            :rules="requiredRules"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <DatePicker
                                            :default-date="newPreviousDental"
                                            v-model="newPreviousDental"
                                            label="Most Recent Dental Visit"
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-textarea
                                            v-model="newDentalNotes"
                                            label="Dental Notes"
                                            outlined
                                            :rules="requiredRules"
                                        ></v-textarea>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                            v-model="newPsychiatrist"
                                            label="Psychiatrist"
                                            :rules="requiredRules"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <DatePicker
                                            :default-date="newPsychEval"
                                            v-model="newPsychEval"
                                            label="Most Recent Psych Evaluation"
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-textarea
                                            v-model="newPsychNotes"
                                            label="Psych Evaluation Notes"
                                            outlined
                                            :rules="requiredRules"
                                        ></v-textarea>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                            v-model="newNeurologist"
                                            label="Neurologist"
                                            :rules="requiredRules"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <DatePicker
                                            :default-date="newPreviousNeuro"
                                            v-model="newPreviousNeuro"
                                            label="Most Recent Neurological Evaluation"
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-textarea
                                            v-model="newNeuroNotes"
                                            label="Neurological Evaluation Notes"
                                            outlined
                                            :rules="requiredRules"
                                        ></v-textarea>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                            v-model="newHospital"
                                            label="Hospital"
                                            :rules="requiredRules"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                            v-model="newPharmacy"
                                            label="Pharmacy"
                                            :rules="requiredRules"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-textarea
                                            v-model="newNewProviders"
                                            label="New Providers"
                                            outlined
                                            :rules="requiredRules"
                                        ></v-textarea>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-textarea
                                            v-model="newAllergies"
                                            label="Allergies"
                                            outlined
                                            :rules="requiredRules"
                                        ></v-textarea>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-textarea
                                            v-model="newDrugAllergies"
                                            label="Drug Allergies"
                                            outlined
                                            :rules="requiredRules"
                                        ></v-textarea>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-textarea
                                            v-model="newImmunizations"
                                            label="Immunizations Needed"
                                            outlined
                                            :rules="requiredRules"
                                        ></v-textarea>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-textarea
                                            v-model="newDietaryNeeds"
                                            label="Dietary Needs"
                                            outlined
                                            :rules="requiredRules"
                                        ></v-textarea>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6"> &nbsp;</v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <h3 class="ma-2">Pattern of Elimination</h3>
                                        <v-row class="ma-2">
                                            <v-switch
                                                label="Constipation"
                                                v-model="newElimination"
                                                value="Constipation"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="Diarrhea"
                                                v-model="newElimination"
                                                value="Diarrhea"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="Incontinent"
                                                value="Incontinent"
                                                v-model="newElimination"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="WNL"
                                                value="WNL"
                                                v-model="newElimination"
                                                class="ma-1"
                                            ></v-switch>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <h3 class="ma-2">Pattern of Urination</h3>
                                        <v-row class="ma-2">
                                            <v-switch
                                                label="Same"
                                                value="Same"
                                                class="ma-1"
                                                v-model="newUrination"
                                            ></v-switch>
                                            <v-switch
                                                label="Frequent"
                                                value="Frequent"
                                                v-model="newUrination"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="Incontinent"
                                                value="Incontinent"
                                                v-model="newUrination"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="WNL"
                                                value="WNL"
                                                v-model="newUrination"
                                                class="ma-1"
                                            ></v-switch>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-textarea
                                            v-model="newAdditionalNotes"
                                            label="Additional Notes"
                                            outlined
                                            :rules="requiredRules"
                                        ></v-textarea>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <h3 class="ma-2">Energy Level</h3>
                                        <v-row class="ma-2">
                                            <v-switch
                                                label="High"
                                                value="High"
                                                v-model="newEnergyLevel"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="Moderate"
                                                value="Moderate"
                                                v-model="newEnergyLevel"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="Low"
                                                value="Low"
                                                v-model="newEnergyLevel"
                                                class="ma-1"
                                            ></v-switch>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-text-field
                                            label="Recent Changes"
                                            v-model="newSleepChanges"
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-text-field
                                            label="Time they fall asleep"
                                            v-model="newSleepTime"
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-text-field
                                            label="Hours of sleep each night"
                                            v-model="newSleepHours"
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <h3 class="ma-2">Night Awakenings</h3>
                                        <v-row class="ma-2">
                                            <v-switch
                                                label="Yes"
                                                value="Yes"
                                                v-model="newAwakenings"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="No"
                                                value="No"
                                                v-model="newAwakenings"
                                                class="ma-1"
                                            ></v-switch>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <h3 class="ma-2">Type of Sleep</h3>
                                        <v-row class="ma-2">
                                            <v-switch
                                                label="Deep"
                                                value="Deep"
                                                v-model="newSleepType"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="Disturbed"
                                                value="Disturbed"
                                                v-model="newSleepType"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="Nightmares"
                                                value="Nightmares"
                                                v-model="newSleepType"
                                                class="ma-1"
                                            ></v-switch>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <h3 class="ma-2">Awareness Level</h3>
                                        <v-row class="ma-2">
                                            <v-switch
                                                label="Alert"
                                                value="Alert"
                                                v-model="newAwareness"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="Oriented"
                                                value="Oriented"
                                                v-model="newAwareness"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="Confused"
                                                value="Confused"
                                                v-model="newAwareness"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="Disoriented"
                                                value="Disoriented"
                                                v-model="newAwareness"
                                                class="ma-1"
                                            ></v-switch>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <h3>Appearance</h3>
                                        <v-row class="ma-2">
                                            <v-switch
                                                label="Clean"
                                                value="Clean"
                                                v-model="newAppearance"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="Dishelveled"
                                                value="Dishelveled"
                                                v-model="newAppearance"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="Appropriate Dress"
                                                value="Appropriate Dress"
                                                v-model="newAppearance"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="Other"
                                                value="Other"
                                                v-model="newAppearance"
                                                class="ma-1"
                                            ></v-switch>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <h3 class="ma-2">Behavior</h3>
                                        <v-row class="ma-2">
                                            <v-switch
                                                label="Polite"
                                                value="Polite"
                                                v-model="newBehavior"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="Condescending"
                                                value="Condescending"
                                                v-model="newBehavior"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="Rude"
                                                value="Rude"
                                                v-model="newBehavior"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="Constricted"
                                                value="Constricted"
                                                v-model="newBehavior"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="Other"
                                                value="Other"
                                                v-model="newBehavior"
                                                class="ma-1"
                                            ></v-switch>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <h3 class="ma-2">Affect</h3>
                                        <v-row class="ma-2">
                                            <v-switch
                                                label="Bright"
                                                value="Bright"
                                                v-model="newAffect"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="Sad"
                                                value="Sad"
                                                v-model="newAffect"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="Agitated"
                                                value="Agitated"
                                                v-model="newAffect"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="Blunted"
                                                value="Blunted"
                                                v-model="newAffect"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="Constricted"
                                                value="Constricted"
                                                v-model="newAffect"
                                                class="ma-1"
                                            ></v-switch>
                                            <v-switch
                                                label="Other"
                                                value="Other"
                                                v-model="newAffect"
                                                class="ma-1"
                                            ></v-switch>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-textarea
                                            label="Summary"
                                            v-model="newSummary"
                                            outlined
                                        ></v-textarea>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-checkbox
                                            v-model="signed"
                                            label="Signature"
                                            @click="addSignature()"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-text-field
                                            v-model="newInterviewerSig"
                                            label="Signed"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                    <v-file-input
                                        v-model="fileUpload"
                                        label="Upload Assessment Document"
                                        prepend-icon="mdi-file"
                                        @change="handleFileUpload"
                                    ></v-file-input>
                                    </v-col>

                                    <v-col cols="12" sm="12" v-if="documentUrl">
                                        <v-card>
                                            <v-card-title>
                                            Uploaded Document
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                icon
                                                small
                                                @click="documentUrl = null"
                                            >
                                                <v-icon>mdi-close</v-icon>
                                            </v-btn>
                                            </v-card-title>
                                            <v-card-text>
                                            <FileViewer
                                                :fileUrl="documentUrl"
                                                :fileName="documentName"
                                            />
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            fab
                            small
                            @click="showPrintModal()"
                            class="mr-8 mb-2 white--text"
                            color="#2b6993"
                            elevation="4"
                            v-if="editAssessment"
                        >
                            <v-icon>print</v-icon>
                        </v-btn>
                        <v-btn
                            class="white--text"
                            color="#259647"
                            @click="addAssessment()"
                            v-if="newAssessment"
                        >Save
                        </v-btn
                        >
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="updateAssessment()"
                            v-if="!newAssessment"
                        >Update
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <Foot/>
    </div>
</template>

<script>
import axios from "axios";
import ClientNav from "../../../components/ClientNav";
import Foot from "../../../components/Footer";
import moment from "moment";
import DatePicker from "@/components/DateTimePickers/DatePicker.vue";
import DateTimeUtil from "../../../../utils/date-time.util";
import {displaySuccess, displayError} from "@/service/notification-message.service";
import PrintUtil from "../../../../utils/print-util";
import FileViewer from '@/components/FileViewer.vue';

const url = require("../../../client_config/config").url;

export default {
    components: {
        DatePicker,
        ClientNav,
        Foot,
        FileViewer
    },
    data() {
        return {
            editAssessment: false,
            newAssessment: false,
            msg: false,
            date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10),
            menu: false,
            menu2: false,
            menu3: false,
            menu4: false,
            menu5: false,
            search: "",
            text: "",
            assessment: {},
            codes: [],
            users: [],
            clientID: this.$route.params.clientID,
            userID: localStorage.getItem("userID"),
            tempData: [],
            titleForm: "New Assessment",
            assessmentId: this.$route.params.id,
            token: localStorage.getItem('token'),
            newDate: "",
            newInterviewer: "",
            newHistory: "",
            newMedicalSupport: "",
            newPhysician: "",
            newPreviousPhysical: "",
            newPhysicalNotes: "",
            newDentist: "",
            newPreviousDental: "",
            newDentalNotes: "",
            newPsychiatrist: "",
            newPsychEval: "",
            newPsychNotes: "",
            newNeurologist: "",
            newPreviousNeuro: "",
            newNeuroNotes: "",
            newHospital: "",
            newPharmacy: "",
            newNewProviders: "",
            newAllergies: "",
            newDrugAllergies: "",
            newImmunizations: "",
            newDietaryNeeds: "",
            newElimination: "",
            newUrination: "",
            newAdditionalNotes: "",
            newEnergyLevel: "",
            newSleepChanges: "",
            newSleepTime: "",
            newAwakenings: "",
            newSleepHours: "",
            newSleepType: "",
            newAwareness: "",
            newAppearance: "",
            newBehavior: "",
            newAffect: "",
            newSummary: "",
            newInterviewerSig: "",
            signed: false,
            staff: localStorage.getItem("Name"),
            isLoading: true,
            requiredRules: [(v) => !!v || "This is required"],
            hide: true,
            fileUpload: null,
            documentUrl: null,
            documentName: '',
        };
    },

    computed: {},

    watch: {},

    created() {
        this.newAssessment = this.$route.query.newAssessment === 'true'

        if (!this.newAssessment) {
            this.getAssessment()
        }
    },

    mounted() {
        window.addEventListener('keydown', async (event) => {
            const downloadUrl = await this.generateDownloadUrl();
            PrintUtil.handleKeydown(event, downloadUrl, this.assessmentId, this.token, 'MedicalHistory');
        });
    },

    beforeDestroy() {
        window.removeEventListener('keydown', (event) => {
            PrintUtil.handleKeydown(event, this.downloadUrl, this.assessmentId, this.token, 'MedicalHistory');
        });
    },

    methods: {
        initialize() {
            this.assessments = [];
        },

        validate() {
            return this.$refs.form.validate();
        },

        handleFileUpload(file) {
            this.fileUpload = file;
            if (file) {
                this.documentUrl = URL.createObjectURL(file);
                this.documentName = file.name;
            } else {
                this.documentUrl = null;
                this.documentName = '';
            }
        },

        viewAssessment(item) {

            this.titleForm = "Viewing Assessment";
            this.dialog = true;
            this.editAssessment = true;
            this.newAssessment = false;
            this.newInterviewer = item.Interviewer;
            this.newDate = moment(item.Date).format("YYYY-MM-DD");
            this.newHistory = item.History;
            this.newMedicalSupport = item.MedicalSupport;
            this.newPhysician = item.Physician;
            this.newPreviousPhysical = moment(item.PreviousPhysical).format("YYYY-MM-DD");
            this.newPhysicalNotes = item.PhysicalNotes;
            this.newDentist = item.Dentist;
            this.newPreviousDental = moment(item.PreviousDental).format("YYYY-MM-DD");
            this.newDentalNotes = item.DentalNotes;
            this.newPsychiatrist = item.Psychiatrist;
            this.newPsychEval = moment(item.PsychEval).format("YYYY-MM-DD");
            this.newPsychNotes = item.PsychNotes;
            this.newNeurologist = item.Neurologist;
            this.newPreviousNeuro = moment(item.PreviousNeuro).format("YYYY-MM-DD");
            this.newNeuroNotes = item.NeuroNotes;
            this.newHospital = item.Hospital;
            this.newPharmacy = item.Pharmacy;
            this.newNewProviders = item.NewProviders;
            this.newAllergies = item.Allergies;
            this.newDrugAllergies = item.DrugAllergies;
            this.newImmunizations = item.Immunizations;
            this.newDietaryNeeds = item.DietaryNeeds;
            this.newElimination = item.Elimination;
            this.newUrination = item.Urination;
            this.newAdditionalNotes = item.AdditionalNotes;
            this.newEnergyLevel = item.EnergyLevel;
            this.newSleepChanges = item.SleepChanges;
            this.newSleepTime = item.SleepTime;
            this.newAwakenings = item.Awakenings;
            this.newSleepHours = item.SleepHours;
            this.newSleepType = item.SleepType;
            this.newAwareness = item.Awareness;
            this.newAppearance = item.Appearance;
            this.newBehavior = item.Behavior;
            this.newAffect = item.Affect;
            this.newSummary = item.Summary;
            this.newInterviewerSig = item.InterviewerSig;
            this.assessmentId = item._id;
            this.signed = item.InterviewerSig !== '';

            if (item.Document) {
                this.documentUrl = item.Document.AWSLink;
                this.documentName = item.Document.Name;
            }

        },

        close() {
            this.clear();
            this.$router.go(-1)
        },

        async updateAssessment() {
            if (this.validate()) {
                const formData = new FormData();

                if (this.fileUpload) {
                    formData.append('Assessments', this.fileUpload);
                }

                const requestBody = {
                    Date: DateTimeUtil.toUTCISOString(new Date(this.newDate)),
                    Interviewer: this.newInterviewer,
                    History: this.newHistory,
                    MedicalSupport: this.newMedicalSupport,
                    Physician: this.newPhysician,
                    PreviousPhysical: DateTimeUtil.toUTCISOString(new Date(this.newPreviousPhysical)),
                    PhysicalNotes: this.newPhysicalNotes,
                    Dentist: this.newDentist,
                    DentalNotes: this.newDentalNotes,
                    PreviousDental: DateTimeUtil.toUTCISOString(new Date(this.newPreviousDental)),
                    Psychiatrist: this.newPsychiatrist,
                    PsychEval: DateTimeUtil.toUTCISOString(new Date(this.newPsychEval)),
                    PsychNotes: this.newPsychNotes,
                    Neurologist: this.newNeurologist,
                    PreviousNeuro: DateTimeUtil.toUTCISOString(new Date(this.newPreviousNeuro)),
                    NeuroNotes: this.newNeuroNotes,
                    Hospital: this.newHospital,
                    Pharmacy: this.newPharmacy,
                    NewProviders: this.newNewProviders,
                    Allergies: this.newAllergies,
                    DrugAllergies: this.newDrugAllergies,
                    Immunizations: this.newImmunizations,
                    DietaryNeeds: this.newDietaryNeeds,
                    Elimination: this.newElimination,
                    Urination: this.newUrination,
                    AdditionalNotes: this.newAdditionalNotes,
                    EnergyLevel: this.newEnergyLevel,
                    SleepChanges: this.newSleepChanges,
                    SleepTime: this.newSleepTime,
                    Awakenings: this.newAwakenings,
                    SleepHours: this.newSleepHours,
                    SleepType: this.newSleepType,
                    Awareness: this.newAwareness,
                    Appearance: this.newAppearance,
                    Behavior: this.newBehavior,
                    Affect: this.newAffect,
                    Summary: this.newSummary,
                    InterviewerSig: this.newInterviewerSig,
                    Signed: this.signed,
                };

                Object.keys(requestBody).forEach(key => {
                    formData.append(key, requestBody[key]);
                });

                try {
                    const response = await axios.put(
                        `${url}/assessments/${this.assessmentId}`,
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                    );

                    if (response.status !== 200) {
                        displayError("There was an error updating the assessment record.");
                        return;
                    }
                    displaySuccess("The assessment has been updated successfully.");
                } catch (error) {
                    displayError(error.response?.data?.message || "Error updating assessment");
                } finally {
                    this.close();
                }
            } else {
                displayError("Please fill all required fields.");
            }
        },

        getAssessment() {
            this.isLoading = true;
            axios
                .get(`${url}/assessments/${this.assessmentId}`)
                .then((res) => {
                    this.assessment = res.data.assessment;
                    if (this.assessment.Document) {
                        this.documentUrl = this.assessment.Document.AWSLink;
                        this.documentName = this.assessment.Document.Name;
                    }
                    this.viewAssessment(this.assessment)
                    this.getUsers();
                })
                .finally(() => (this.isLoading = false));
        },

        getUsers() {
            axios.get(`${url}/users`).then(async (res) => {
                this.users = res.data.users;
                for (var i = 0; i < this.users.length; i++) {
                    if (this.userID == this.users[i]._id) {
                        this.staff = this.users[i].Name;
                    }
                }
            });
        },

        addSignature() {
            if (!this.signed) {
                return (this.newInterviewerSig = "");
            }
            this.newInterviewerSig = this.staff + " - " + new Date();
            this.signed = true;
        },

        async addAssessment() {
            if (this.validate()) {
                const formData = new FormData();

                if (this.fileUpload) {
                    formData.append('Assessments', this.fileUpload);
                }

                const requestBody = {
                    Date: this.newDate ? DateTimeUtil.toUTCISOString(new Date(this.newDate)) : null,
                    Interviewer: this.newInterviewer,
                    History: this.newHistory,
                    MedicalSupport: this.newMedicalSupport,
                    Physician: this.newPhysician,
                    PreviousPhysical: this.newPreviousPhysical ? DateTimeUtil.toUTCISOString(new Date(this.newPreviousPhysical)) : null,
                    PhysicalNotes: this.newPhysicalNotes,
                    Dentist: this.newDentist,
                    DentalNotes: this.newDentalNotes,
                    PreviousDental: this.newPreviousDental ? DateTimeUtil.toUTCISOString(new Date(this.newPreviousDental)) : null,
                    Psychiatrist: this.newPsychiatrist,
                    PsychEval: this.newPsychEval ? DateTimeUtil.toUTCISOString(new Date(this.newPsychEval)) : null,
                    PsychNotes: this.newPsychNotes,
                    Neurologist: this.newNeurologist,
                    PreviousNeuro: this.newPreviousNeuro ? DateTimeUtil.toUTCISOString(new Date(this.newPreviousNeuro)) : null,
                    NeuroNotes: this.newNeuroNotes,
                    Hospital: this.newHospital,
                    Pharmacy: this.newPharmacy,
                    NewProviders: this.newNewProviders,
                    Allergies: this.newAllergies,
                    DrugAllergies: this.newDrugAllergies,
                    Immunizations: this.newImmunizations,
                    DietaryNeeds: this.newDietaryNeeds,
                    Elimination: this.newElimination,
                    Urination: this.newUrination,
                    AdditionalNotes: this.newAdditionalNotes,
                    EnergyLevel: this.newEnergyLevel,
                    SleepChanges: this.newSleepChanges,
                    SleepTime: this.newSleepTime,
                    Awakenings: this.newAwakenings,
                    SleepHours: this.newSleepHours,
                    SleepType: this.newSleepType,
                    Awareness: this.newAwareness,
                    Appearance: this.newAppearance,
                    Behavior: this.newBehavior,
                    Affect: this.newAffect,
                    Summary: this.newSummary,
                    InterviewerSig: this.newInterviewerSig,
                    ClientID: this.clientID,
                    Signed: this.signed,
                };

                Object.keys(requestBody).forEach(key => {
                    formData.append(key, requestBody[key]);
                });

                try {
                    const response = await axios.post(
                        `${url}/assessments`,
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                    );

                    if (response.status !== 200) {
                        displayError("There was an error creating the assessment record.");
                        return;
                    }
                    displaySuccess("The new assessment has been added successfully.");
                } catch (error) {
                    displayError(error.response?.data?.message || "Error creating assessment");
                } finally {
                    this.close();
                }
            } else {
                displayError("Fill up missing information.");
            }
        },

        clear() {
            this.newDate = "";
            this.newInterviewer = "";
            this.newHistory = "";
            this.newMedicalSupport = "";
            this.newPhysician = "";
            this.newPreviousPhysical = "";
            this.newPhysicalNotes = "";
            this.newDentist = "";
            this.newPreviousDental = "";
            this.newDentalNotes = "";
            this.newPsychiatrist = "";
            this.newPsychEval = "";
            this.newPsychNotes = "";
            this.newNeurologist = "";
            this.newPreviousNeuro = "";
            this.newNeuroNotes = "";
            this.newHospital = "";
            this.newPharmacy = "";
            this.newNewProviders = "";
            this.newAllergies = "";
            this.newDrugAllergies = "";
            this.newImmunizations = "";
            this.newDietaryNeeds = "";
            this.newElimination = "";
            this.newUrination = "";
            this.newAdditionalNotes = "";
            this.newEnergyLevel = "";
            this.newSleepChanges = "";
            this.newSleepTime = "";
            this.newAwakenings = "";
            this.newSleepHours = "";
            this.newSleepType = "";
            this.newAwareness = "";
            this.newAppearance = "";
            this.newBehavior = "";
            this.newAffect = "";
            this.newSumary = "";
            this.newInterviewerSig = "";
            this.fileUpload = null;
            this.documentUrl = null;
            this.documentName = '';
        },

        async generateDownloadUrl() {
            let id = this.assessmentId;
            return `${url}/assessments/print?id=${id}`;
        },

        async showPrintModal() {
            const downloadUrl = await this.generateDownloadUrl();
            PrintUtil.showPrintOption(downloadUrl, this.assessmentId, this.token, 'MedicalHistory');
        },

    },
};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
}
</style>
